module.exports = __webpack_public_path__ + "static/img/avatar_logo.689960c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/avatar_logo.png
// module id = lHPT
// module chunks = 0